exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".scoped-headhunter .filter-result{margin:20px 0}.scoped-headhunter .filter-result .list-item-bottom{background:#fff}.scoped-headhunter .filter-result .list-item:not(:first-child){margin-top:20px}.scoped-headhunter .filter-result .list-item .line-text-1,.scoped-headhunter .filter-result .list-item .line-text-2{margin:5px 0}.scoped-headhunter .filter-result .list-item-body .operate-btn-area button{display:block;width:100%;margin-left:0}.scoped-headhunter .filter-result .list-item-body .operate-btn-area button:not(:first-child){margin-top:5px}.scoped-headhunter .filter-result .title{font-size:16px}.scoped-headhunter .filter-result .c-tips{color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f1dcf77","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/supplier/supplierList.vue
// module id = 961
// module chunks = 23